module.exports = __webpack_public_path__ + "assets/img/btn-view-all-fd522f60.png";